import { TabLines } from '@design/components/tab-lines/TabLines';
import { useTranslation } from 'react-i18next';

import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '../useEarningsInsightDrawer';
import styles from './EarningsInsightWidget.module.scss';

export const EarningsInsightTabLines = () => {
  const { t } = useTranslation(['earnings']);
  const { activeTab, switchTab } = useEarningsInsightDrawer();

  return (
    <TabLines
      className={styles.root}
      tabs={[
        {
          tabKey: SubTabsType.Preview,
          tabLabel: t('earnings:earningsInsight.drawer.earningsPreview.title'),
        },
        {
          tabKey: SubTabsType.Recap,
          tabLabel: t('earnings:earningsInsight.drawer.earningsRecap.title'),
        },
      ]}
      activeTab={activeTab}
      onChange={index => switchTab(index)}
    />
  );
};
